var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.234,
    height: 20.234,
    viewBox: "0 0 20.234 20.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard-act",
    d: "M197.973,195.773a2.531,2.531,0,0,0-3.8,2.473c-2.956.621-5.076,1.751-5.076-1.559a7.588,7.588,0,1,1,15.176,0c0,3.31-2.12,2.18-5.076,1.559a2.586,2.586,0,0,0,.017-.294,2.517,2.517,0,0,0-.35-1.285l3.22-3.22a.624.624,0,0,0,0-.892.638.638,0,0,0-.892,0ZM196.688,206.8a10.117,10.117,0,1,0-10.117-10.117A10.117,10.117,0,0,0,196.688,206.8Zm0-7.588a1.258,1.258,0,1,0-.9-.368,1.265,1.265,0,0,0,.9.368Z",
    transform: "translate(-186.571 -186.566)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard_active.b6b306c4534e651d5cb5387e7a02acf6.svg";
export { ForwardRef as ReactComponent };